module.exports = __webpack_public_path__ + "img/useSlide08.f30a7c20.jpg";